import { useSelector } from 'react-redux';
import { isDesktopLayoutSelector } from '../redux/reducers/ui/layoutMode';

export const useIsDesktopLayout = () => {
  return useSelector(isDesktopLayoutSelector);
};
